(function () {
  const ACTIVE_CLASS = 'active';

  function closeMegaMenus() {
    document
      .querySelectorAll('.mega-menu-wrapper.' + ACTIVE_CLASS)
      .forEach(m => m.classList.remove(ACTIVE_CLASS));

    document
      .querySelectorAll('[data-mega-trigger]')
      .forEach(t => {
        t.setAttribute('aria-expanded', 'false');

        const parent = t.parentElement;
        if (parent) {
          parent.classList.remove('mega-open');
        }
      });
  }

  function closeNormalDropdowns() {
    document
      .querySelectorAll('header .header__inline-menu details[open]')
      .forEach(d => d.removeAttribute('open'));
  }

  function closeAll() {
    closeMegaMenus();
    closeNormalDropdowns();
  }

  const header = document.querySelector('.section-header');
  if (!header) return;

  function checkHeaderVisibility() {
    const rect = header.getBoundingClientRect();
    const style = window.getComputedStyle(header);

    const isOutOfViewport = rect.bottom <= 0;
    const isTranslatedUp =
      style.transform !== 'none' &&
      style.transform.includes('-');

    if (isOutOfViewport || isTranslatedUp) {
      closeMegaMenus();
      closeNormalDropdowns();
    }
  }

  window.addEventListener('scroll', checkHeaderVisibility, { passive: true });

  // 🔥 OPEN / CLOSE HANDLER
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-mega-trigger]');
    const panel = e.target.closest('.mega-menu-wrapper');
    const normalDropdown = e.target.closest('header details');

    // 👉 Click inside mega menu (not trigger) → do nothing
    if (panel && !trigger) return;

    // 👉 Click on MEGA trigger
    if (trigger) {
      e.preventDefault();

      const targetPanel = trigger.nextElementSibling;
      if (!targetPanel) return;

      const isOpen = targetPanel.classList.contains(ACTIVE_CLASS);

      closeAll();

      if (!isOpen) {
        targetPanel.classList.add(ACTIVE_CLASS);
        trigger.setAttribute('aria-expanded', 'true');
        const parent = trigger.parentElement;
        if (parent) {
          parent.classList.add('mega-open');
        }
      }

      return;
    }

    // 👉 Click inside NORMAL dropdown
    if (normalDropdown) {
      closeMegaMenus(); // close mega only
      return;
    }

    // 👉 Click outside everything
    closeAll();
  });

  // 🔥 CATEGORY TAB SWITCHING
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('.mega-tab');
    if (!tab) return;

    e.preventDefault();

    const wrapper = tab.closest('.mega-products');
    if (!wrapper) return;

    const target = tab.dataset.tab;

    wrapper.querySelectorAll('.mega-tab')
      .forEach(t => t.classList.remove('active'));

    wrapper.querySelectorAll('.mega-products-panel')
      .forEach(p => p.classList.remove('active'));

    tab.classList.add('active');

    const targetPanel = wrapper.querySelector('[data-panel="' + target + '"]');
    if (targetPanel) targetPanel.classList.add('active');
  });

})();













document.addEventListener('click', (e) => {
  const arrow = e.target.closest('.mega-arrow');
  if (!arrow) return;

  e.preventDefault();

  const panel = arrow.closest('.mega-products-panel');
  const track = panel.querySelector('[data-carousel]');
  const card = track.querySelector('.mega-product-card');

  if (!card) return;

  const gap = parseInt(getComputedStyle(track).gap) || 20;
  const scrollAmount = (card.offsetWidth + gap) * 4;

  track.scrollBy({
    left: arrow.classList.contains('mega-arrow--right')
      ? scrollAmount
      : -scrollAmount,
    behavior: 'smooth'
  });
});
